import { useGetChallengeDetails } from "@/layout/ChallengeSubmissionWrapper/hooks/useGetChallengeDetails";
import { UserChallengeStatus } from "@/services/challenges/types/challenges.enums";
import { ChallengeType } from "@/services/challenges/types/challenges.types";
import Theme from "@/utils/theme";
import { useCallback, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { useRegistrationCompletion } from "@/hooks/useRegistrationCompletion";

export const useCaseChallengeSubmission = () => {
  const { id } = useParams();
  const { isRegistrationComplete } = useRegistrationCompletion();
  const { data: challenge } = useGetChallengeDetails({
    type: "case",
    id: Number(id),
  });

  const [isOpenQuizId, setIsOpenQuizId] = useState<number>();

  const challengeStatus = useMemo(() => {
    if (isRegistrationComplete) {
      return {
        color: Theme.colors.feedback.positive,
        text: "Concluído",
      };
    }

    if (challenge?.status === UserChallengeStatus.SENT) {
      return {
        color: Theme.colors.feedback.info,
        text: "Enviado",
      };
    }

    if (challenge?.status === UserChallengeStatus.FINISHED) {
      return {
        color: Theme.colors.feedback.info,
        text: "Enviado",
      };
    }

    if (challenge?.status === UserChallengeStatus.REJECTED) {
      return {
        color: Theme.colors.feedback.negative,
        text: "Reprovado",
      };
    }

    return {
      color: Theme.colors.feedback.warning,
      text: "Pendente",
    };
  }, [challenge?.status, isRegistrationComplete]);

  const getQuizStatus = useCallback(
    (quiz: ChallengeType) => {
      if (isRegistrationComplete) {
        return {
          color: Theme.colors.feedback.positive,
          text: "Concluído",
        };
      }

      if (quiz?.status === UserChallengeStatus.FINISHED) {
        return {
          color: Theme.colors.feedback.info,
          text: "Enviado",
        };
      }

      return {
        color: Theme.colors.feedback.warning,
        text: "Pendente",
      };
    },
    [isRegistrationComplete]
  );

  const quizzes = useMemo(() => {
    return (
      challenge?.quizzes?.map((q) => ({ ...q, status: getQuizStatus(q) })) ?? []
    );
  }, [challenge, getQuizStatus]);

  const currentQuiz = useMemo(() => {
    if (!isOpenQuizId || !challenge?.quizzes) return undefined;

    return challenge?.quizzes.find((quiz) => quiz.id === isOpenQuizId);
  }, [isOpenQuizId, challenge]);

  return {
    challenge,
    challengeStatus,
    quizzes,

    currentQuiz,
    setIsOpenQuizId,
  };
};
